import { DISEASES } from '@/constants/disease'
import store from '@/store'

const summarizedFlow = store.getters['auth/pharmaceuticalDomainConfig'].SUMMARIZEDFLOW

export const PERSONAL_HISTORY_OPTIONS = [
  {
    key: 'diarreia_cronica',
    name: 'Tem diarreia crônica, dor abdominal ou outras alterações de hábito intestinal?',
    disabled: (diseaseId) => diseaseId === DISEASES.ESPONDILOARTRITIS,
    required: summarizedFlow,
  },
  {
    key: 'uveite',
    name: 'Tem olhos vermelhos, fotofobia, lacrimejamento ou outras alterações visuais (uveíte)?',
    disabled: (diseaseId) => diseaseId === DISEASES.ESPONDILOARTRITIS,
    required: summarizedFlow,
  },
  {
    key: 'tuberculose',
    name: 'Já teve ou está com tuberculose ativa ou latente?',
    options: [
      { text: 'Sim', value: 'SIM' },
      { text: 'Não', value: 'NÃO' },
      { text: 'Tratada', value: 'TRATADA' },
      { text: 'Em tratamento', value: 'EM_TRATAMENTO' },
    ],
    required: summarizedFlow,
  },
  {
    key: 'tuberculose_latente',
    name: 'Teve exposição prévia ou trabalha exposto a pessoas com possível tuberculose ativa?',
    required: summarizedFlow,
  },
]

export const PERSONAL_HISTORY_FEMALE_OPTIONS = [
  {
    key: 'gravidez',
    name: 'Está grávida ou pretende engravidar durante o tratamento?',
  },
  {
    key: 'contracepcao',
    name: 'Contracepção?',
    required: summarizedFlow,
  },
]

export const FAMILY_HISTORY_OPTIONS = [
  {
    key: 'psoriase',
    name: 'Psoríase na família?',
    degrees: ['1º', '2º', '3º'],
    required: summarizedFlow,
  },
  {
    key: 'esclerose_multipla',
    name: 'Alguém na família tem esclerose mútlipla? (Como esclerose múltipla, neuropatia óptica ou outras síndromes desemielinizantes)',
    degrees: ['1º', '2º', '3º'],
    required: summarizedFlow,
  },
]

export const COMORBIDITIES_OPTIONS = [
  { key: 'lupus', name: 'Lupus' },
  { key: 'insuficiencia_renal', name: 'Insuficiência renal' },
  { key: 'doenca_lesoes_preexistentes', name: 'Doenças ou Lesões Preexistentes ' },
  { key: 'hipertensao_arterial_sistemica', name: 'Hipertensão Arterial Sistêmica' },
  { key: 'esteatose_hepatica', name: 'Esteatose hepática' },
  { key: 'cirrose_fibrose_hepatica', name: 'Cirrose ou fibrose hepática' },
  {
    key: 'hepatite_b',
    name: 'Hepatite B',
    complex: true,
  },
  {
    key: 'hepatite_c',
    name: 'Hepatite C',
    complex: true,
  },
  {
    key: 'hiv',
    name: 'HIV',
    complex: true,
  },
  { key: 'fibrose_pulmonar', name: 'Fibrose pulmonar' },
  {
    key: 'doenca_inflamatoria_intestinal',
    name: 'Doença inflamatória intestinal',
  },
  { key: 'dm_intolerancia__glicose', name: 'DM/intolerância à glicose' },
  { key: 'dislipidemia', name: 'Dislipidemia' },
  { key: 'insuficiencia_cardiaca_grau_iii_iv', name: 'Insuficiência cardíaca grau III ou IV' },
  { key: 'esclerose_multipla_doenca_desmielinizante', name: 'Esclerose múltipla ou doença desmielinizante' },
  { key: 'asma', name: 'Asma' },
  { key: 'alergias', name: 'Alergias' },
  { key: 'dermatite_contato', name: 'Dermatite de contato' },
  { key: 'erupcao_variceliforme_kaposi', name: 'Erupção variceliforme de Kaposi' },
  {
    key: 'transtorno_depressivo_ansiedade_generalizada',
    name: 'Transtorno depressivo e de ansiedade generalizada',
  },
  { key: 'fibromialgia', name: 'Fibromialgia' },
  { key: 'doenca_auto_imune_reumatologica', name: 'Doença auto-imune/reumatológica' },
  { key: 'cancer_exceto_pele', name: 'Câncer (exceto de pele)' },
  { key: 'cancer_pele_carcinoma', name: 'Câncer (carcinoma)' },
  { key: 'cancer_pele_melanoma', name: 'Câncer (melanoma)' },
  { key: 'cancer_pele_nao_identificado', name: 'Câncer (subtipo não identificado)' },
  { key: 'rinite_alergica', name: 'Rinite alérgica' },
  { key: 'polipo_nasal_polipose_sinusal', name: 'Pólipo nasal ou diagnóstico de polipose sinusal' },
  { key: 'conjuntivite', name: 'Conjuntivite' },
  { key: 'herpes_simples', name: 'Herpes simples' },
  { key: 'neoplasia', name: 'Neoplasia' },
  { key: 'outras_comorbidades', name: 'Outras comorbidades' },
]
